// GAVION batch 3: every M365 function answers m365_not_configured until the Entra app exists.
// Retrying cannot help then, so status queries stop at once; other errors get 3 bounded retries.
import { M365ApiError } from "./types";

export const isM365NotConfigured = (e: unknown): boolean =>
  e instanceof M365ApiError && e.code === "m365_not_configured";

/** react-query `retry` for M365 queries. */
export const m365QueryRetry = (failureCount: number, e: unknown): boolean =>
  !isM365NotConfigured(e) && failureCount < 3;
